import { BrowserModule, HammerModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule, TransferState } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient } from '@angular/common/http';


import { HouseDetailsComponent } from './houses/house-details.component';
import { OfferDetailsComponent } from './offers/offer-details.component';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { HeaderComponent } from './shared/header/header.component';
import { AppFooterComponent } from './shared/footer/footer.component';
import { ImagesCarouselComponent } from './shared/images-carousel/images-carousel.component';

import { MatIconModule } from '@angular/material/icon';

// Translate
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { exportTranslateStaticLoader } from 'libs/common/src/i18n/translate-browser-loader.service';

import { MatButtonModule } from '@angular/material/button';
import { CommonThemeModule } from 'common';

import localeRoExtra from '@angular/common/locales/extra/ro';
import { registerLocaleData } from '@angular/common';
import localeRo from '@angular/common/locales/ro';
registerLocaleData(localeRo, 'ro-RO', localeRoExtra);

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    AppFooterComponent,
    HouseDetailsComponent,
    OfferDetailsComponent,
    ImagesCarouselComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    AppRoutingModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: exportTranslateStaticLoader,
        deps: [HttpClient, TransferState],
      },
    }),
    CommonThemeModule,
    MatIconModule,
    HammerModule,
    MatButtonModule,
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'ro-RO'},
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
